// 着座メモ履歴のフィルタから、問い合わせてよいかと問い合わせ内容を決める。
//
// これが無かったせいで、日付欄を消した瞬間に「期間なし」のリクエストが飛び、
// サーバが 400 を返して一覧がエラー画面に置き換わっていた（2026-09-27 の不具合）。
// スマホの日付ピッカーは入力途中に空文字を返すので、画面側で止める必要がある。
//
// サーバ側の判定は worker/src/seat-memo-query.mjs。あちらが権限の正であり、
// ここは「壊れた条件を投げない」「理由をその場で出す」ための写し。

export const MAX_RANGE_DAYS = 31; // 両端を含めた日数。サーバ側と揃えること。

const DATE_RE = /^\d{4}-\d{2}-\d{2}$/;
const DAY_MS = 86400000;

function parseDate(s) {
  if (typeof s !== 'string' || !DATE_RE.test(s)) return null;
  const [y, m, d] = s.split('-').map(Number);
  const ms = Date.UTC(y, m - 1, d);
  if (new Date(ms).toISOString().slice(0, 10) !== s) return null;
  return ms;
}

/**
 * @param {{user_id?: string, date_from?: string, date_to?: string, result?: string}} filter
 * @param {{isAdmin: boolean}} viewer
 * @returns {{ready: true, params: object} | {ready: false, reason: string}}
 */
export function buildSeatMemoQuery(filter, { isAdmin }) {
  const { user_id, date_from, date_to, result } = filter || {};

  // 期間は画面が常に埋めている。空＝ユーザーが消した／入力途中。
  // 0件表示にすると「その期間にメモが無い」と誤解されるので、問い合わせずに促す。
  if (!date_from) return { ready: false, reason: '開始日を選んでください' };
  if (!date_to) return { ready: false, reason: '終了日を選んでください' };

  const from = parseDate(date_from);
  const to = parseDate(date_to);
  if (from == null || to == null) return { ready: false, reason: '日付を選び直してください' };
  if (from > to) return { ready: false, reason: '開始日が終了日より後になっています' };

  const allUsers = isAdmin && user_id === 'all';
  if (allUsers) {
    const days = Math.round((to - from) / DAY_MS) + 1;
    if (days > MAX_RANGE_DAYS) {
      return { ready: false, reason: `全員分を見られるのは${MAX_RANGE_DAYS}日までです（いまは${days}日）` };
    }
  }

  const params = { date_from, date_to };
  // 管理者以外は user_id を送らない（サーバ側でも自分の分に落とされる）。
  if (isAdmin && user_id) params.user_id = user_id;
  if (result) params.result = result;
  return { ready: true, params };
}
